// TODO: make this an .env
let MAILCHIMP_ID = '';
let CONSTANT_CONTACT_ID = '';

if(
    window.location.host.indexOf('localhost') !== -1
    ||
    window.location.host.indexOf('.local') !== -1
) {
    MAILCHIMP_ID = '806399212806';
    //export const MAILCHIMP_SECRET = 'c571795289c069d55956874ef8ba3a6269bde4b435a9479527';
    CONSTANT_CONTACT_ID = '37c7cw94wpr8kpvhz5rh2tjn';
    // export const CONSTANT_CONTACT_SECRET = 'sExCT77XtrVEsfjMU7bVw5j8';
} else if(window.location.host.indexOf('.staging') !== -1) {
    MAILCHIMP_ID = '949959910110';
    //export const MAILCHIMP_SECRET = '96d02a73d447707c058d2a8910641b86f42df9cc791832eb51';
    CONSTANT_CONTACT_ID = 'wp7jc56d266u82b3vx7zk55u';
    // export const CONSTANT_CONTACT_SECRET = 'yDduGBHbSNaBMUbxYUqkXMza';
} else {
    MAILCHIMP_ID = '653270210325';
    //export const MAILCHIMP_SECRET = '995eeb4b0327ed0c98cdae27f750e6d993b364dd179f9904d5';
    CONSTANT_CONTACT_ID = 'fkdpym9dcrnqaqauxuug3xq3';
    //export const CONSTANT_CONTACT_SECRET = 'c6KyGj9NDcK4CK46RbMahZkY';
}

export {
    MAILCHIMP_ID,
    CONSTANT_CONTACT_ID,
};
